/** Six digits, whatever spaces the authenticator app shows between them. */
export function normalizeTotp(value: string): string {
  return value.replace(/\s+/g, '');
}
